import { render, staticRenderFns } from "./AddressDetail.vue?vue&type=template&id=3f431c12&scoped=true"
import script from "./AddressDetail.vue?vue&type=script&lang=js"
export * from "./AddressDetail.vue?vue&type=script&lang=js"
import style0 from "./AddressDetail.vue?vue&type=style&index=0&id=3f431c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f431c12",
  null
  
)

export default component.exports